import React from 'react';
import { Modal, Button } from "react-bootstrap";
import Result from "components/Question/Result/Result";
import TemplateDetectorModal from "components/PracticeMaterial/PopUps/TemplateDetectorModal";

export default function ResultPopup({
	isAnswer, resultData,
	speakingResult, writingResult, readingResult, writeFromDictationResult, listeningResult,
	fail, newResult, newHtml, subcategoryId, renderResponse, correctAnswer,
	option_explaination, historyData, toggleResultPopup,
	question_id, question_title, recorded_file, question, script,
	
	template_issue, template_type, common_sentence, score, explanationModal,
	templateDetectorModalProps, closeModalExplanation,html,speed_percentage
}) {

	const checkTemplateDetected = () => {
		return template_type ? true : false;
	}

	return (
		<>
			{checkTemplateDetected() ? (
				<TemplateDetectorModal
                  isOpen={true}
                  {...templateDetectorModalProps}
				  newResult={newResult}
                  closeModal={toggleResultPopup}
                />
			) : (
				<Modal show={true} centered size="lg" className="text-translate-modal p-0">
					{/* result-popup-section */}
					<Modal.Header className="d-flex border-0">
						<Modal.Title className="text-translation popup_heading m-0">
						  Score Info
						</Modal.Title>
				
						<Button variant="link" className="modalClose-Btn p-0" onClick={toggleResultPopup} style={{top: "16px"}}>
						  <svg
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 24 24"
							width="24"
							height="24"
						  >
							<path
							  d="M18 6L6 18M6 6l12 12"
							  stroke="currentColor"
							  strokeWidth="2"
							  strokeLinecap="round"
							  strokeLinejoin="round"
							/>
						  </svg>
						</Button>
					</Modal.Header>
						{/* <div className='custom-line mx-2' ></div> */}
					<Modal.Body>
						{/* <h2 className='result-sub-title'>{question_title}</h2> */}
						<Result
							question_id={question_id}
							isAnswer={isAnswer}
							resultData={resultData}
							speakingResult={speakingResult}
							writingResult={writingResult}
							readingResult={readingResult}
							writeFromDictationResult={writeFromDictationResult}
							listeningResult={listeningResult}
							fail={fail}
							newResult={newResult}
							newHtml={newHtml}
							subcategoryId={subcategoryId}
							renderResponse={renderResponse}
							correctAnswer={correctAnswer}
							option_explaination={option_explaination}
							historyData={historyData}
							isPopup={true}
							recorded_file={recorded_file}
							question={question}
							script={script}
							html={html}
							speed_percentage={speed_percentage}
						/>
					</Modal.Body>
				</Modal>
			)}
		</>
	);
}